import React from "react";

const AddAfterIcon = class extends React.Component {
	render() {
		return (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 32 32"
				fill="currentColor"
				stroke="none"
				style={this.props.style || {}}
			>
				<path d="M20,14.75h-7.25v7.25h-3.5v-7.25H2v-3.5h7.25v-7.25h3.5v7.25h7.25v3.5ZM18,22l6,8,6-8-4.05.61c2.82-8.3-1.36-16.4-2.42-16.05-1.34.44,4.49,9.3-1.51,16.02l-4.02-.59Z"/>
			</svg>
		);
	}
}

export default AddAfterIcon;